import { CLEAR_INVOICE_DETAIL, FETCH_INVOICE_DETAILS} from "../../actions/actionTypes";

const initialState = {
    data: [],
    isLoading: false,
    next:null
};

const reducer = (state=initialState, action)=>{
    // console.log("action",action)
    switch(action.type){
        case  FETCH_INVOICE_DETAILS.REQUEST:
            return {...state, isLoading: true}
        case  FETCH_INVOICE_DETAILS.FAILURE:
            return {...state, isLoading:false}
        case  FETCH_INVOICE_DETAILS.SUCCESS:     
        return {
            ...state,
            data: action.obj.isLoadMore ? [...state.data,...action.obj.data] : action.obj.data,
            next: action.obj.next,
            isLoading:false
          };
        case CLEAR_INVOICE_DETAIL:
            return initialState;      
        default:
            return state
    }   
}

export default reducer;

